import { makeStyles } from '@material-ui/core/styles';

const COLORS = {
  lighterRed: '#fdeded',
  lightRed: '#ffa3a3',
  darkRed: '#430000',
  lightGreen: '#c2fac4',
  darkGreen: '#003502',
};

export const useStyles = makeStyles(theme => ({
  banner: {
    marginBottom: theme.spacing(2),
    fontWeight: 'bold',
  },
  errorBanner: {
    background: COLORS.lighterRed,
    color: COLORS.darkRed,
  },
  card: {
    '& .MuiCardHeader-root': {
      padding: theme.spacing(1, 2),
      fontSize: '1rem',
    },
  },
  errorCard: {
    '& .MuiCardHeader-root': {
      background: COLORS.lightRed,
      color: COLORS.darkRed,
    },
  },
  successCard: {
    '& .MuiCardHeader-root': {
      background: COLORS.lightGreen,
      color: COLORS.darkGreen,
    },
  },
  cardTitle: {
    fontSize: '1rem',
  },
  cardSubheader: {
    fontSize: '0.75rem',
    color: 'inherit',
    opacity: 0.7,
  },
  cardContent: {
    padding: theme.spacing(1, 2),
  },
  count: {
    fontSize: '3rem',
    fontWeight: 'bold',
    lineHeight: 1,
    textAlign: 'center',
  },
  label: {
    fontSize: '0.875rem',
    marginTop: theme.spacing(1),
    opacity: 0.8,
    textAlign: 'center',
  },
}));
